import React from "react";

export default function UAUCAllHeader({
  title,
  query,
  setQuery,
  assignedToId,
  setAssignedToId,
  assigneeOptions,
  advOpen,
  setAdvOpen,
  onBack,
  stats,
}) {
  return (
    <div className="rounded-t-3xl bg-gradient-to-br from-slate-950 via-slate-900 to-sky-950 px-5 py-5 text-white">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.18em] text-sky-300">
            Observation Control
          </p>
          <h4 className="mt-2 text-2xl font-black tracking-tight">{title}</h4>
          <p className="mt-1 text-sm font-medium text-slate-300">
            Review all observations by status, assignee, risk, SLA and closure
            performance.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <input
            className="h-11 w-72 rounded-2xl border border-white/10 bg-white/10 px-4 text-sm font-bold text-white outline-none placeholder:text-slate-400 focus:border-sky-300"
            placeholder="Search observer, area, hazards..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />

          <select
            value={assignedToId}
            onChange={(e) => setAssignedToId(e.target.value)}
            className="h-11 rounded-2xl border border-white/10 bg-white/10 px-3 text-sm font-bold text-white outline-none"
          >
            <option value="">All Assignees</option>
            {assigneeOptions.map((option) => (
              <option
                key={option.id}
                value={option.id}
                className="text-slate-900"
              >
                {option.name}
              </option>
            ))}
          </select>

          <button
            type="button"
            onClick={() => setAdvOpen((value) => !value)}
            className="h-11 rounded-2xl bg-white px-4 text-sm font-black text-slate-950"
          >
            {advOpen ? "Close Filters" : "Advanced Filters"}
          </button>

          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="h-11 rounded-2xl border border-white/10 bg-white/10 px-4 text-sm font-black text-white"
            >
              Back
            </button>
          )}
        </div>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3 lg:grid-cols-4">
        <div className="rounded-2xl border border-white/10 bg-white/10 p-4">
          <p className="text-xs font-bold uppercase tracking-wide text-slate-300">
            Total
          </p>
          <p className="mt-2 text-2xl font-black tabular-nums">{stats.total}</p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/10 p-4">
          <p className="text-xs font-bold uppercase tracking-wide text-slate-300">
            Open
          </p>
          <p className="mt-2 text-2xl font-black text-yellow-200 tabular-nums">
            {stats.open}
          </p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/10 p-4">
          <p className="text-xs font-bold uppercase tracking-wide text-slate-300">
            Closed
          </p>
          <p className="mt-2 text-2xl font-black text-emerald-200 tabular-nums">
            {stats.closed}
          </p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/10 p-4">
          <p className="text-xs font-bold uppercase tracking-wide text-slate-300">
            Overdue/Late
          </p>
          <p className="mt-2 text-2xl font-black text-red-200 tabular-nums">
            {stats.slaRisk}
          </p>
        </div>
      </div>
    </div>
  );
}
